module.exports = __webpack_public_path__ + "static/media/19Demo Photo-ink.24478785.jpeg";